import { render, staticRenderFns } from "./ItemStorages.vue?vue&type=template&id=0ecee110"
import script from "./ItemStorages.vue?vue&type=script&lang=js"
export * from "./ItemStorages.vue?vue&type=script&lang=js"
import style0 from "./ItemStorages.vue?vue&type=style&index=0&id=0ecee110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports